// -----------------------------------------------------------------------------------------------------------------
// Restricted - Copyright (C) Siemens Healthineers AG 2023.
// -----------------------------------------------------------------------------------------------------------------

export const windowLocation = {
  setWindowLocationHRef(url: string): void {
    window.location.href = url;
  },
};
